import { ChangeEvent, useState } from 'react'
import { AiFillCheckCircle } from 'react-icons/ai'
import { BiHome } from 'react-icons/bi'
import { HiOutlineSwitchHorizontal } from 'react-icons/hi'
import { Link } from 'react-router-dom'

import Modal from './Modal'
import { UserRole } from '../components/types'
import UserProfile from './UserProfile'

type NavBarProps = {
  titleHome?: string
  username: string,
  role: string,
  allRoles?: UserRole[]  
  onSignout: () => {}
  onCheckNewVersion: () => {}
  children?: JSX.Element
}

const NavBar = ({ 
  titleHome = 'Home',
  username,
  role,
  allRoles,
  onSignout,
  onCheckNewVersion,
  children
}: NavBarProps) => {
  const [ isExpand, setExpand ] = useState(false)
  const [ showSwitchRole, setShowSwitchRole ] = useState<boolean>(false)

  const onSwitchRole = (e: ChangeEvent<HTMLInputElement>) => {
    localStorage.setItem('currentRole', e.currentTarget.value)
    setShowSwitchRole(false)
    window.location.replace('/')
  }

  return <>
    <nav className="flex flex-wrap items-center justify-between p-2 bg-header">
      <Link to="/" className="flex items-center flex-shrink-0 mr-6 text-white">
        <BiHome className='mr-1'/>
        <span className="text-xl font-semibold tracking-tight">{titleHome}</span>
      </Link>
      <div className="block md:hidden">
        <button title='menu' onClick={() => setExpand(!isExpand)} className="flex items-center px-3 py-2 text-white border border-white rounded hover:text-white hover:border-white">
          <svg className="w-3 h-3 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
        </button>
      </div>
      <div id="responsive-menu" className={`flex-grow ${isExpand ? '':'hidden '}w-full md:flex md:items-center md:w-auto`}>
        <div className="text-base md:flex-grow">
          {children}
        </div>
        <UserProfile
          username={username}
          role={role}
          disabledSwitchRole={!allRoles || allRoles.length === 0}
          onCheckNewVersion={onCheckNewVersion}
          onSwitchRole={() => setShowSwitchRole(true)}
          onSignOut={onSignout}
        />
      </div>
    </nav>
    <Modal
      title='เปลี่ยน Role'
      subTitle='เลือก Role ที่ต้องการใช้งาน'
      TitleIcon={HiOutlineSwitchHorizontal}
      show={showSwitchRole}
      onHide={() => setShowSwitchRole(false)}
      showCloseButton={true}
    >
    <>
      <div className='space-y-3 '>
        {allRoles?.map(r =>
        <div className="relative switch-role" key={r.name}>
          <input
            className="hidden peer"
            type="radio"
            id={`radio${r.name}`}
            value={r.name}
            name={`radio${r.name}`}
            onChange={onSwitchRole}
            checked={r.name === role}
          />
          <label className="flex items-center justify-between gap-3 p-4 border border-gray-300 rounded-lg cursor-pointer peer-checked:text-blue-600" htmlFor={`radio${r.name}`}>
            <span className=''>{r.name}{r.readOnly ? ' - Read Only' : ''}</span>
          </label>
          <AiFillCheckCircle size={24} className='absolute text-blue-600 -translate-x-[200%] -translate-y-1/2 opacity-0 top-1/2 left-full peer-checked:opacity-100' />
        </div>
        )}
      </div>
    </>
    </Modal>
  </>
}

export default NavBar